import { BalanceSheetId, Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { balanceSheetsQueryKey, financialPeriodsQueryKey } from "../../financials";

export function useAdminUpdateBalanceSheetPeriod(accountId: SuretyAccountId) {
	const { patch } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: ({
			balanceSheetId,
			body,
		}: {
			balanceSheetId: BalanceSheetId;
			body: Dtos.Admin.BalanceSheet.UpdatePeriod.Request;
		}) =>
			patch<Dtos.Admin.BalanceSheet.UpdatePeriod.Response>(
				`/v2/admin/surety/accounts/${accountId}/balance-sheets/${balanceSheetId}/period`,
				body,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: balanceSheetsQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: financialPeriodsQueryKey(accountId) });
		},
	});

	return {
		updateBalanceSheetPeriod: mutation.mutate,
		updateBSPeriodLoading: mutation.isPending,
		updateBSPeriodError: mutation.error,
		resetUpdateBSPeriodError: mutation.reset,
	};
}
